<template>
  <!-- multiple selection dropdown  -->
  <b-dropdown
    v-if="type"
    text="Select Actions"
    class="d-flex align-items-center mx-3 top-page-btn m-md-2 custom-selectWidth"
    variant="primary"
    size="sm"
  >
    <template v-slot:button-content>
      <!-- Actions for selections
      <i class="mdi mdi-chevron-down"></i> -->
      <span class="custom-fontActions">Actions for selections</span>
      <svg
        style="margin-inline-start: 8px"
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="white"
          d="M3.91961 4.64098C4.01093 4.74571 4.12395 4.82975 4.25102 4.88734C4.37809 4.94494 4.51622 4.97475 4.65598 4.97475C4.79573 4.97475 4.93384 4.94494 5.06091 4.88734C5.18798 4.82975 5.30103 4.74571 5.39235 4.64098L8.87415 0.810973C9.27819 0.363973 9.11961 0.000975021 8.51254 0.000975126L0.799387 0.000976461C0.193327 0.000976566 0.0337599 0.366974 0.4378 0.810974L3.91961 4.64098Z"
        />
      </svg>
    </template>

    <b-dropdown-item v-b-modal="'moveUserTypes'" @click="setActionData(data)"
      >Move</b-dropdown-item
    >
    <b-dropdown-item @click="deleteModal">Delete</b-dropdown-item>
  </b-dropdown>

  <!-- single selection dropdown  -->
  <div v-else>
    <DxDropDownButton
      :items="items"
      :drop-down-options="{ width: 140, maxHeight: 179 }"
      :scrollable="true"
      :text="$t('common.grid.selectActions')"
      id="selectActionsUserTypes"
      class="selectActions"
      itemTemplate="actionsTemp"
    >
      <!-- <template v-slot:button-content>
      <span class="custom-fontActions">Available Actions</span>
      <svg style="margin-inline-start: 8px" width="10" height="5" viewBox="0 0 10 5" fill="none"  xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" fill="white"
         d="M3.91961 4.64098C4.01093 4.74571 4.12395 4.82975 4.25102 4.88734C4.37809 4.94494 4.51622 4.97475 4.65598 4.97475C4.79573 4.97475 4.93384 4.94494 5.06091 4.88734C5.18798 4.82975 5.30103 4.74571 5.39235 4.64098L8.87415 0.810973C9.27819 0.363973 9.11961 0.000975021 8.51254 0.000975126L0.799387 0.000976461C0.193327 0.000976566 0.0337599 0.366974 0.4378 0.810974L3.91961 4.64098Z"/>
      </svg>
    </template>
    
    <b-dropdown-item-button v-b-modal="'updateUserTypes'" @click="setActionData(data)">Edit</b-dropdown-item-button>
    <b-dropdown-item-button v-if="data.isChild && hasAtLeastOneParent" v-b-modal="'moveUserTypes'" @click="setActionData(data)">Move</b-dropdown-item-button>
    <b-dropdown-item-button v-if="data.can_delete" @click="deleteModal">Delete</b-dropdown-item-button> -->

      <template #actionsTemp="{ data }">
        <div
          :class="{
            'users-actions-seperator':
              data.id == 'editUserType' || data.id == 'moveUserType',
            'high-users-actions-seperator': data.id == 'deleteUserType',
          }"
          class="dropdown-wrapper"
          title=""
          v-b-modal="data.modalId"
          @click="setActionData(UserTypeData)"
        >
          <div
            class="dropdown-items"
            :class="{ 'red-remove': data.id == 'deleteUserType' }"
            title=""
          >
            {{ data.text }}
          </div>
        </div>
      </template>
    </DxDropDownButton>
  </div>
</template>

<script>
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { mapActions } from "vuex";
export default {
  name: "ActionsUserType",
  props: ["UserTypeData", "type", "hasAtLeastOneParent", "parentIds"],
  components: {
    DxDropDownButton,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    ...mapActions("userType", ["deleteUserType"]),
    ...mapActions("modal", ["setData"]),
    setActionData(data) {
      this.setData(data);
    },
  },
  created() {
    if (
      this.parentIds &&
      this.parentIds.length == 1 &&
      this.parentIds[0] == this.UserTypeData.parentId
    )
      this.hasAtLeastOneParent = false;
  },
  beforeMount() {
    this.items.push(
      {
        id: "editUserType",
        text: this.$t("common.edit"),
        modalId: "updateUserTypes",
        visible: true,
      },
      {
        id: "moveUserType",
        text: this.$t("common.move"),
        modalId: "moveUserTypes",
        visible: this.UserTypeData.isChild && this.hasAtLeastOneParent,
      },
      {
        id: "deleteUserType",
        text: this.$t("common.delete"),
        modalId: "deleteUserTypeModal",
        visible: this.UserTypeData.can_delete,
      }
    );
  },
};
</script>
<style lang="scss">
.high-users-actions-seperator {
  border-top: 5px solid #e0e0e0 !important;
}
.dropdown-wrapper {
  padding: 0;

  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 12px auto 12px auto !important;
    white-space: break-spaces;
  }

  .red-remove {
    color: #f46a6a !important;
  }
}

.users-actions-seperator {
  border-bottom: 1px solid #e0e0e0 !important;
}

.dx-scrollable-scroll.dx-state-invisible,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
}
.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
</style>

<style lang="scss" scoped>
.custom-signinout {
  margin-inline-start: 16px;
  margin-inline-end: 10px;
  width: 146px;
  height: 27px;
  color: #ffffff;
  background: #2680eb;
  border-radius: 72px;
  border: none !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  cursor: pointer !important;
}
.custom-signinout:disabled {
  opacity: 0.4;
  color: #ffffff;
  cursor: pointer !important;
}
</style>
